import { Component, OnInit, ViewChild } from '@angular/core';
import { RepairGroup } from './repair-group';
import { RepairGroupService } from './repair-group.service';
import { ActivatedRoute } from '@angular/router';
import { Message } from 'primeng/api';
import { Status } from '../status/status';
import { StatusService } from '../status/status.service';

@Component({
    templateUrl: './repair-group.component.html'
})

export class RepairGroupComponent implements OnInit {

    @ViewChild('myTable') myTable;

    items: RepairGroup[] = [];
    item: RepairGroup = { id: null, description: null, status: null };
    outItem: RepairGroup;
    selectedItem: RepairGroup;
    msgs: Message[] = [];
    statuslist: Status[] = [];

    constructor(
        private activatedRoute: ActivatedRoute,
        private service: RepairGroupService,
        private statusService: StatusService,
    ) { }

    ngOnInit() {
        this.statusService.findAll().subscribe(status => {
            this.statuslist = status.filter(x => x.type == "Master");
        });

        this.activatedRoute.params.subscribe(params => {
            this.items = this.activatedRoute.snapshot.data['items'];
        });
    }

    newItem() {
        this.msgs = [];
        this.selectedItem = { id: null, description: null, status: null};
        this.items = [this.selectedItem].concat(this.items);
        this.myTable.first = 0;
    }

    delete(item: RepairGroup) {
        this.msgs = [];
        if (item.id != null){
           this.service.delete(item).subscribe( (data) => {
            const deletedItem = this.items.find(x => x.id === item.id);
            this.items.splice(this.items.indexOf(deletedItem), 1);
            this.msgs.push({
                severity: 'success',
                detail: 'Registro excluído'
            });
           }, (err) => {
            this.msgs.push({
                severity: 'error',
                detail: 'Não é possível excluir o registro'
            });
           });
        }
    }

    save(item: RepairGroup) {
        this.msgs = [];
        if (item.description == null) this.msgs.push({severity:'error', detail:'Descrição obrigatória'});
        if (item.status == null) this.msgs.push({severity:'error', detail:'Status obrigatório'});
        
        let msg = this.checkExist(item);
        if(msg) {
            this.msgs.push({
                severity: 'error',
                detail: msg
            });
        }

        if (this.msgs.length > 0)
            return;

        if (item.id == null){
            this.service.save(item).subscribe( 
                params => {
                    item.id = params.id;

                    this.msgs.push({
                        severity: 'success',
                        detail: 'Registro incluído'
                    });
                } , error => {
                    this.msgs.push({severity:'error', detail:'Não é possível salvar o registro!'});
                    this.selectedItem = null;
                }
            , );
        } else {
            this.service.update(item).subscribe((data) => {
                this.msgs.push({
                    severity: 'success',
                    detail: 'Registro modificado'
                });
            } , error => {
                this.msgs.push({severity:'error', detail:'Não é possível salvar o registro55555555!'});
                this.selectedItem = null;
            });
        }
        this.selectedItem = null;
    }

    checkExist(item: RepairGroup){
        if (item.id == null){
            for(let i = 0; i < this.items.length; i++) {
                if(this.items[i].id && this.items[i].description.trim().toUpperCase() == item.description.trim().toUpperCase()) {
                    return 'Não foi possível efetuar o cadastro. Registro já existe';
                }
            }
        } else {
            let quantity = 0;
            for(let i = 0; i < this.items.length; i++) {
                if(this.items[i].description.trim().toUpperCase() == item.description.trim().toUpperCase()) {
                    quantity++;
                    if(quantity > 1 ) {
                        return 'Não foi possível efetuar o cadastro. Registro já existe';
                    }
                } 
            }
        }
    }

    cancel(item : RepairGroup) {
        this.msgs = [];
        if (this.selectedItem.id == null) {
            this.items.shift();
        }

        if(this.outItem != null && this.outItem.id != null){
            item.description = this.outItem.description;
            item.status = this.outItem.status;
        }

        this.selectedItem = null;
        this.outItem = null;
    }

    edit(item: RepairGroup) {
        this.msgs = [];
        this.selectedItem = item;
        this.outItem = this.clone(item);
    }

    clone(i: RepairGroup): RepairGroup{
        let item = {id: null, description: null, status:null};
        for(let prop in i){
            item[prop] = i[prop];
        }
        return item;
    }

}